// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "807904763e5b4619093827e5aaae7e4b" + ".js";
};